import React from 'react';
import { makeStyles } from '@material-ui/core';
import { BodyTextSmall } from '@modernhealth/vital-components';

import type { InvoicingPageStepProps } from '../types';
import { useFormatDateTime } from '../hooks/useFormatDateTime';

export const InfoCallout: React.FC<{ data: InvoicingPageStepProps['data'] }> = ({ data }) => {
  const styles = useStyles();
  const formatDateTime = useFormatDateTime();

  return (
    <div className={styles.callout}>
      <BodyTextSmall>
        <strong>Client name:</strong> {data.visit?.coachAssignment?.member?.fullName}
      </BodyTextSmall>
      <BodyTextSmall>
        <strong>Session date and time:</strong> {formatDateTime(data.visit?.scheduledTime)}
      </BodyTextSmall>
      <BodyTextSmall>
        <strong>Session type:</strong>{' '}
        {data.visit?.isPsychiatryInitialEvaluation
          ? 'Initial evaluation (60 minutes)'
          : 'Follow-up (30 minutes)'}
      </BodyTextSmall>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  callout: {
    backgroundColor: '#E0E2E9',
    padding: 16,
  },
}));
